"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseError = exports.RequestError = exports.RequestResponseBaseError = void 0;
var tslib_1 = require("tslib");
/**
 *  @module Errors
 */
var arrify_1 = tslib_1.__importDefault(require("arrify"));
var APIError_js_1 = require("./APIError.js");
var isSymbol = function (value) {
    return ["string", "number", "boolean"].includes(typeof value);
};
/**
 * The function format the ill-formatted errors:
 * - When errors is not an array, use it as the only error
 * - Filters null and undefined errors
 * - When an item of errors is a symbol rather than an object, returns the UNKNOWN_ERROR as the code
 */
var formatErrors = function (_a) {
    var rawErrors = _a.errors, rest = tslib_1.__rest(_a, ["errors"]);
    var errorList = (0, arrify_1.default)(rawErrors);
    var formattedErrors = errorList.filter(Boolean).map(function (error) {
        if (typeof error === "string") {
            var errorCodeKeys = tslib_1.__spreadArray(tslib_1.__spreadArray([], tslib_1.__read(Object.keys(APIError_js_1.ResponseErrorCode)), false), tslib_1.__read(Object.keys(APIError_js_1.RequestErrorCode)), false);
            var upperCaseError_1 = error.toUpperCase();
            var isValidError = errorCodeKeys.some(function (key) { return APIError_js_1.ResponseErrorCode[key] === upperCaseError_1 || APIError_js_1.RequestErrorCode[key] === upperCaseError_1; });
            return {
                reason: isValidError ? upperCaseError_1 : APIError_js_1.ResponseErrorCode.UnknownError,
                field: null,
                rawError: error,
            };
        }
        if (isSymbol(error)) {
            return { reason: APIError_js_1.ResponseErrorCode.UnknownError, field: null, rawError: error };
        }
        return error;
    });
    return tslib_1.__assign(tslib_1.__assign({}, rest), { errors: formattedErrors });
};
var serializeErrorResponse = function (_a) {
    var code = _a.code, httpCode = _a.httpCode, errors = _a.errors;
    var formattedErrors = errors.map(function (error) {
        return "field" in error && !!error.field ? "".concat(error.reason, " (").concat(error.field, ")") : "".concat(error.reason);
    });
    return "Code: ".concat(code, ", HttpCode: ").concat(httpCode, ", Errors: ").concat(formattedErrors.join(", "));
};
var RequestResponseBaseError = /** @class */ (function (_super) {
    tslib_1.__extends(RequestResponseBaseError, _super);
    function RequestResponseBaseError(errorResponse) {
        var _this = this;
        var formattedErrorResponse = formatErrors(errorResponse);
        _this = _super.call(this, serializeErrorResponse(formattedErrorResponse)) || this;
        Object.setPrototypeOf(_this, RequestResponseBaseError.prototype);
        _this.errorResponse = tslib_1.__assign({ status: "error" }, formattedErrorResponse);
        return _this;
    }
    return RequestResponseBaseError;
}(Error));
exports.RequestResponseBaseError = RequestResponseBaseError;
var RequestError = /** @class */ (function (_super) {
    tslib_1.__extends(RequestError, _super);
    function RequestError(errorResponse) {
        var _this = _super.call(this, errorResponse) || this;
        Object.setPrototypeOf(_this, RequestError.prototype);
        return _this;
    }
    return RequestError;
}(RequestResponseBaseError));
exports.RequestError = RequestError;
var ResponseError = /** @class */ (function (_super) {
    tslib_1.__extends(ResponseError, _super);
    function ResponseError(errorResponse) {
        var _this = _super.call(this, errorResponse) || this;
        Object.setPrototypeOf(_this, ResponseError.prototype);
        return _this;
    }
    return ResponseError;
}(RequestResponseBaseError));
exports.ResponseError = ResponseError;
//# sourceMappingURL=RequestResponseError.js.map